import { useLocalStorage } from '@vueuse/core';
export const defaultHazardAppearancePreferences = Object.freeze({
    showImages: false,
    hideND: true,
});
const LEGACY_VUEX_STORAGE_KEY = 'vuex';
const HAZARD_APPEARANCE_STORAGE_KEY = 'hazard.appearance';
const migrateLegacyHazardAppearance = () => {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined')
        return;
    try {
        const rawLegacyStore = window.localStorage.getItem(LEGACY_VUEX_STORAGE_KEY);
        if (!rawLegacyStore)
            return;
        const parsedLegacyStore = JSON.parse(rawLegacyStore);
        const legacyHazard = parsedLegacyStore?.hazard;
        const legacyFilters = legacyHazard?.hazardReportFilters;
        if (!legacyHazard || !legacyFilters || !('hideND' in legacyFilters))
            return;
        const rawAppearance = window.localStorage.getItem(HAZARD_APPEARANCE_STORAGE_KEY);
        const appearance = rawAppearance ? JSON.parse(rawAppearance) : {};
        if (!('hideND' in appearance)) {
            window.localStorage.setItem(HAZARD_APPEARANCE_STORAGE_KEY, JSON.stringify({
                ...appearance,
                hideND: legacyFilters.hideND,
            }));
        }
        const nextLegacyFilters = { ...legacyFilters };
        delete nextLegacyFilters.hideND;
        window.localStorage.setItem(LEGACY_VUEX_STORAGE_KEY, JSON.stringify({
            ...parsedLegacyStore,
            hazard: {
                ...legacyHazard,
                hazardReportFilters: nextLegacyFilters,
            },
        }));
    }
    catch {
        // Keep defaults when storage is unavailable or contains invalid data.
    }
};
migrateLegacyHazardAppearance();
export const hazardAppearancePreference = useLocalStorage(HAZARD_APPEARANCE_STORAGE_KEY, { ...defaultHazardAppearancePreferences }, { mergeDefaults: true });
